import * as React from 'react';
import { ArticleParagraph1, LinkButton } from '@cian/ui-kit';

import * as styles from './NewbuildingBlackFridayBanner.css';

interface INewbuildingBlackFridayBannerProps {
  url: string;
}

export function NewbuildingBlackFridayBanner({ url }: INewbuildingBlackFridayBannerProps) {
  return (
    <div className={styles['container']} data-testid="BlackFridayBanner">
      <h2 className={styles['title']} role="presentation">
        Чёрная пятница 16-24 ноября
      </h2>
      <div className={styles['description']}>
        <ArticleParagraph1 color="white_100">
          Эксклюзивные скидки на новостройки от застройщиков и банков
        </ArticleParagraph1>
      </div>
      <div className={styles['button-wrapper']}>
        <LinkButton href={url} target="_blank" rel="noreferer noopener" theme="fill_white_primary" size="M">
          Подробнее
        </LinkButton>
      </div>
    </div>
  );
}
